module.exports = __webpack_public_path__ + "img/ka.42e65448.png";